import React, { useEffect, useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonImg,
    IonText
} from '@ionic/react';

// Background categories
const patternBackground: { [key: string]: string[] } = {
    animals: ["elephant.png", "zebra.png", "monkey.png", "horse.png", "wolf.png", "yak.png", "tiger.png", "lion.png", "snake.png", "sheep.png", "rhino.png", "kangaroo.png", "rat.png", "rabbit.png", "dog.png", "cat.png", "cow.png", "pig.png", "fox.png", "lemur.png", "leopard.png", "joey.png", "gorilla.png", "goat.png", "giraffe.png", "donkey.png", "cheetah.png", "camel.png", "buffalo.png", "bison.png", "bear.png"],
    insects: ["butterfly.png", "bee.png", "spider.png", "ant.png", "ladybug.png", "mosquito.png", "grasshoper.png", "dragonfly.png", "beetle.png", "caterpillar.png", "wasp.png", "moth.png", "cricket.png", "firefly.png", "termite.png", "leafhopper.png"],
    flowers: ["sunflower.png", "lotus.png", "rose.png", "lily.png", "daisy.png", "tulip.png", "marigold.png", "jasmine.png", "hibiscus.png", "daffodil.png", "poppy.png", "lavender.png", "orchid.png", "dahlia.png", "aster.png", "magnolia.png"],
    vehicles: ["car.png", "bicycle.png", "airplane.png", "ambulance.png", "bike.png", "bus.png", "truck.png", "motorcycle.png", "scooter.png", "firetruck.png", "train.png", "policecar.png", "jeep.png", "rickshaw.png", "ship.png", "boat.png", "yacht.png"],
    things: ["binoculars.png", "books.png", "candles.png", "ball.png", "dolls.png", "pencil.png", "eraser.png", "crayon.png", "schoolbag.png", "chair.png", "table.png", "umbrella.png", "clock.png", "mug.png", "scissors.png", "sharpener.png"]
};

const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

const shuffleArray = <T,>(arr: T[]): T[] => {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
};



const OddOneOutGame: React.FC = () => {
    const [question, setQuestion] = useState<{ images: string[]; correctIndex: number } | null>(null);
    const [selected, setSelected] = useState<number | null>(null);
    const [feedback, setFeedback] = useState("");
    const [showImage, setShowImage] = useState(false);

    const generateQuestion = () => {
        const categories = Object.keys(patternBackground);
        const mainCategory = getRandomItem(categories);
        const oddCategory = getRandomItem(categories.filter(cat => cat !== mainCategory));

        const mainItems = patternBackground[mainCategory];
        const oddItems = patternBackground[oddCategory];

        const chosenMain: string[] = [];
        while (chosenMain.length < 3) {
            const item = getRandomItem(mainItems);
            if (!chosenMain.includes(item)) chosenMain.push(item);
        }

        const oddItem = getRandomItem(oddItems);
        const combined = shuffleArray([...chosenMain, oddItem]);
        const correctIndex = combined.indexOf(oddItem);

        console.log(combined)

        setQuestion({
            images: combined,
            correctIndex
        });
    };

    const handleSelect = (index: number) => {
        if (!question) return;
        setSelected(index);
        if (index === question.correctIndex) {
            setFeedback("🎉 Correct! Well done!");
            setTimeout(() => {
                setShowImage(true);
                setTimeout(() => {
                    setShowImage(false);
                    generateQuestion()
                    setSelected(null);
                    setFeedback('')
                }, 3000);
            }, 1000);
        } else {
            setFeedback("❌ Try again!");
        }
    };

    useEffect(() => {
        generateQuestion();
        document.title =
            "Mamas Guidance - OLYMPIAD - Logical Reasoning - Odd One Out";
    }, []);

    if (!question) return <p>Loading...</p>;

    return (
        <>
            {!showImage ? (
                <div className="contentPart  fillPreposition additionWord ">
                    <div>
                        <IonText>
                            <h2>Pick the picture that doesn’t belong</h2>
                        </IonText>

                        <div className='grid-container'>
                            {question?.images.map((img, idx) => (
                                <div className='oddOneOut grid-box' key={idx}>
                                    <img
                                        src={`${process.env.REACT_APP_API_URL ?? ""}${img ?? "question-mark.png"}`}
                                        alt={`option-${idx}`}
                                        onClick={() => handleSelect(idx)}
                                        style={{
                                            border: selected === idx
                                                ? idx === question.correctIndex
                                                    ? "4px solid green"
                                                    : "4px solid red"
                                                : "2px solid #ccc",
                                            borderRadius: "12px",
                                            padding: "4px",
                                            cursor: "pointer"
                                        }}
                                    />
                                </div>
                            ))}
                        </div>

                        <IonText color={selected === question?.correctIndex ? "success" : "danger"}>
                            <h3>{feedback}</h3>
                        </IonText>
                    </div>
                </div>

            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK ?? ""}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default OddOneOutGame;
